/**
 * 業務マップ（F1）の oRPC contract。
 *
 * @graph-stack spec-console
 * @graph-domain Engineering
 * @graph-business 業務マップの読取 procedure の入出力を oRPC contract として定義する。
 * @graph-connects none
 */
import { GetBusinessMapInputSchema, GetBusinessMapOutputSchema, } from '../spec-graph-business-map.js';
import { base } from './common.js';
/**
 * 業務マップの読取 procedure（`specGraph` に載る）。
 * @graph-connects none
 */
export const businessMapContract = {
    getBusinessMap: base.input(GetBusinessMapInputSchema).output(GetBusinessMapOutputSchema),
};
//# sourceMappingURL=business-map.js.map